/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Onboarding_Invalid_NumberInputs */

const en_us2_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter a number between ${i?.min} and ${i?.max}.`)
};

const pt_br2_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Digite um número entre ${i?.min} e ${i?.max}.`)
};

const es_419_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escribe un número entre ${i?.min} y ${i?.max}.`)
};

const pt_pt2_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Introduz um número entre ${i?.min} e ${i?.max}.`)
};

const fr_fr2_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saisis un nombre entre ${i?.min} et ${i?.max}.`)
};

const de_de2_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gib eine Zahl zwischen ${i?.min} und ${i?.max} ein.`)
};

const it_it2_onboarding_invalid_number = /** @type {(inputs: Onboarding_Invalid_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inserisci un numero tra ${i?.min} e ${i?.max}.`)
};

/**
* | output |
* | --- |
* | "Enter a number between {min} and {max}." |
*
* @param {Onboarding_Invalid_NumberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_invalid_number = /** @type {((inputs: Onboarding_Invalid_NumberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Invalid_NumberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_invalid_number(inputs)
	if (locale === "es-419") return es_419_onboarding_invalid_number(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_invalid_number(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_invalid_number(inputs)
	if (locale === "de-DE") return de_de2_onboarding_invalid_number(inputs)
	if (locale === "it-IT") return it_it2_onboarding_invalid_number(inputs)
	return en_us2_onboarding_invalid_number(inputs)
});
export { onboarding_invalid_number as "onboarding.invalid_number" }